import React, { useState } from 'react';
import { Modal, Radio } from 'antd';
import { useAuth } from '../../providers/AuthProvider';
import { CommitmentOptions } from '../talent-preferences/components/DashboardPreferences';
import Form, { FormInputComponent } from '../../components/form/Form';
import SpinLoader from "../../components/SpinLoader";

// only show this modal if an approved talent is missing talent_commitment_level

const TalentCommitmentLevelModal = (props) => {
    const { auth, talentUpdate } = useAuth();
    const [isCommitmentModalOpen, setIsCommitmentModalOpen] = useState(auth.isTalent() && auth.isApplicationApproved() &&
        (!auth.talent_commitment_level || auth.has_full_time_employment_interest === null)
    )
    const [preferences, setPreferences] = useState(TB.pick(auth?.talentPreferences(), [
        'talent_commitment_level',
        'has_full_time_employment_interest'
    ]))
    const [isDisabled, setIsDisabled] = useState(false);

    const handleSubmit = async () => {
        await setIsDisabled(true);
        const updatedAuth = await talentUpdate(preferences).catch(console.warn);
        await setIsDisabled(false);

        if (updatedAuth) {
            // await setPreferences(updatedAuth.talentPreferences());
            TB.sysAlert('talent.work_preferences_updated');
            setIsCommitmentModalOpen(false);
            return true;
        } else {
            await TB.showServerErrorToast();
            return false;
        }
    }

    return (
        <Modal
            title={null}
            open={isCommitmentModalOpen}
            closable={false}
            maskClosable={false}
            className="change-order-form-container"
            zIndex={199}
            width={600}
            footer={null}
        >
            <SpinLoader isLoading={isDisabled}>
                <Form
                    showRequired
                    className="work-preference-form pref-questionnaire-form"
                    background={'transparent'}
                    title={null}
                    subtitle={null}
                    minimal
                    submitButton={false}
                    onSubmit={null}
                    model={preferences}
                    onChange={async (model) => {
                        if (isDisabled) return;
                        return setPreferences(model);
                    }}
                    fields={[]}
                    isDisabled={isDisabled}
                >
                    <p className="text-lg font-semibold mb-2">
                        Confirm your work preferences
                    </p>
                    <FormInputComponent
                        value={preferences.talent_commitment_level}
                        fieldName="talent_commitment_level"
                        label="Choose an option below that best describes your current work status"
                        type="antd-input"
                    >
                        <Radio.Group
                            className="flex gap-4 pt-3"
                            name="talent_commitment_level"
                            disabled={isDisabled}
                        >
                            {Object.keys(CommitmentOptions).map(key => {
                                return (
                                    <Radio key={key} value={Number(key)}>
                                        <span className="flex flex-col items-start gap-1">
                                            <span className="text-sm font-medium">
                                                {CommitmentOptions[key].title}
                                            </span>
                                            <span className="text-xxs">
                                                {CommitmentOptions[key].description}
                                            </span>
                                        </span>
                                    </Radio>
                                )
                            })}
                        </Radio.Group>
                    </FormInputComponent>

                    <div className="pt-6">
                        <FormInputComponent
                            value={preferences.has_full_time_employment_interest}
                            fieldName="has_full_time_employment_interest"
                            label="Would you be interested in a permanent employment opportunity?"
                            type="antd-input"
                        >
                            <Radio.Group
                                className="flex gap-2"
                                optionType="button"
                                buttonStyle="solid"
                            >
                                <Radio value={true}
                                    className="flex flex-col items-start justify-center">
                                    Yes
                                </Radio>
                                <Radio value={false}
                                    className="flex flex-col items-start justify-center">
                                    No
                                </Radio>
                            </Radio.Group>
                        </FormInputComponent>
                    </div>


                    <div className="flex flex-row px-4 mt-5 items-center gap-3 justify-end">
                        <button
                            type="button"
                            className="btn btn-primary"
                            disabled={isDisabled || !preferences.talent_commitment_level || (preferences.has_full_time_employment_interest === null || preferences.has_full_time_employment_interest === undefined)}
                            onClick={handleSubmit}
                        >
                            Submit
                        </button>
                    </div>
                </Form>
            </SpinLoader>
        </Modal>
    )
}

export default TalentCommitmentLevelModal;